import React from 'react'

import type { useFloatingElement } from 'hooks/useFloatingElement'

type FloatingElement = ReturnType<typeof useFloatingElement>

export type TooltipPropsContextValue = Pick<
  FloatingElement,
  | 'arrowRef'
  | 'arrowStyle'
  | 'floating'
  | 'floatingStyle'
  | 'middlewareData'
  | 'reference'
> & {
  hasArrow: boolean
  isToggled: boolean
}

export type TooltipHandlersContextValue = {
  onBlur: () => void
  onFocus: () => void
  onMouseEnter: () => void
  onMouseLeave: () => void
  onTouchStart: (event: React.TouchEvent<HTMLElement>) => void
  onTouchEnd: () => void
}

export const TooltipPropsContext = React.createContext<
  TooltipPropsContextValue | undefined
>(undefined)
export const TooltipHandlersContext = React.createContext<
  TooltipHandlersContextValue | undefined
>(undefined)
